export class Ticket{
  constructor(
    public ID:number,
    public Contract_ID:number,
    public total:number,
    public collector:number,
    public seller:number,
    private folio:string,
    private modify_timestamp:string,
    public name:string

  )
  {

  }
}
/*
SELECT t.folio as folio, t.total as total, concat(e.name," ",e.father_last_name," ",e.father_last_name) as seller, t.modify_timestamp
FROM Ticket t
JOIN Employee e
ON t.Employe_ID = e.ID
ORDER BY t.modify_timestamp DESC*/



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/ticket.model.ts